import React from "react";

// reactstrap components
import {
  Button,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import { DialogTitle, Dialog, DialogActions } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { appUrl } from '../../config';
// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import LandingPageHeader from "components/Headers/LandingPageHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";

// core components

class InfoPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      msgdiag: "",
      Quees: { text: "" },
      selected: {},
      lastFocus: false,
      firstFocus: false,
      Fiel: { text: "" },
      Quees2: { text: "" },
      Mision: { text: "" },
      Vision: { text: "" },
    }
  }

  componentDidMount() {
    try {
      var Quees = this.props.info.filter(function (hero) {
        return hero.value == "Quees";
      });
      this.setState({ Quees: Quees[0] })
      var Fiel = this.props.info.filter(function (hero) {
        return hero.value == "Fiel";
      });
      this.setState({ Fiel: Fiel[0] })
      var Quees2 = this.props.info.filter(function (hero) {
        return hero.value == "Quees2";
      });
      this.setState({ Quees2: Quees2[0] })
      var Mision = this.props.info.filter(function (hero) {
        return hero.value == "Mision";
      });
      this.setState({ Mision: Mision[0] })
      var Vision = this.props.info.filter(function (hero) {
        return hero.value == "Vision";
      });
      this.setState({ Vision: Vision[0] })
    } catch (error) {
      console.log("error", error)
    }
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    return function cleanup() {
      document.body.classList.remove("landing-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }

  handleClickOpen = (event, msgdiag) => {
    this.setState({ open: true, msgdiag: msgdiag.text, selected: msgdiag._id });
  }

  handleClose = () => {
    this.setState({ open: false, msgdiag: "" });
  }
  handleChangetype = name => event => {
    this.setState({ [name]: event.target.value });
  };
  handleClick = (event) => {
    console.log("messa", this.state.msgdiag)
    var info =
      { _id: this.state.selected, text: this.state.msgdiag }

    fetch(appUrl + '/updateinfo', {
      method: 'post',
      body: JSON.stringify({
        info: info
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.props.onChange("info", {});
          alert('Información guardada')
        } else {
          alert('No se pudo guardar la información')
        }
      });

  };
  render() {
    return (
      <>

        <ExamplesNavbar onChange={this.props.onChange} products={this.props.products} user={this.props.user} userstatus={this.props.userstatus} admin={this.props.admin} />
        <div className="wrapper">
          <LandingPageHeader />
          <div className="section section-about-us">
            <Container>
              <Row>
                <Col className="ml-auto mr-auto text-center" md="8">
                  <h2 className="title">¿Quienes somos?</h2>
                  {this.props.admin ?
                    <Tooltip title="Editar" aria-label="add">
                      <Fab variant="extended" onClick={event => this.handleClickOpen(event, this.state.Quees)} >
                        <EditIcon />
                      </Fab>
                    </Tooltip>
                    : null}
                  <h3 >
                    {/* {this.state.Quees.text} */}
                    Texto Aqui
                  </h3>
                </Col>
              </Row>
              <div className="separator separator-primary"></div>
              <div className="section-story-overview">
                <Row>
                  <Col md="6">
                    <div
                      className="image-container image-left"
                      style={{
                        backgroundImage:
                          "url(" + require("assets/img/5.jpeg") + ")"
                      }}
                    >
                      <p className="blockquote blockquote-info">
                        {this.props.admin ?
                          <Tooltip title="Editar" aria-label="add">
                            <Fab variant="extended" onClick={event => this.handleClickOpen(event, this.state.Fiel)} >
                              <EditIcon />
                            </Fab>
                          </Tooltip>
                          : null}
                        <h4>Somos fieles a usted</h4>
                        {/* {this.state.Fiel.text} */}
                        Texto Aqui
                      </p>


                    </div>
                  </Col>
                  <Col md="6">
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <div
                      className="image-container image-right"
                      style={{
                        backgroundImage:
                          "url(" + require("assets/img/4.jpeg") + ")"
                      }}
                    ></div>
                    <br></br>
                    {this.props.admin ?
                      <Tooltip title="Editar" aria-label="add">
                        <Fab variant="extended" onClick={event => this.handleClickOpen(event, this.state.Quees2)} >
                          <EditIcon />
                        </Fab>
                      </Tooltip>
                      : null}
                    <h3>
                      {/* {this.state.Quees2.text} */}
                      Texto Aqui
                    </h3>
                    <br></br>
                  </Col>
                </Row>
                <Row>
                  <Col className="ml-auto mr-auto text-center" md="8">
                    <br></br>
                    <h2 className="title">Nuestra Misión</h2>
                    {this.props.admin ?
                      <Tooltip title="Editar" aria-label="add">
                        <Fab variant="extended" onClick={event => this.handleClickOpen(event, this.state.Mision)} >
                          <EditIcon />
                        </Fab>
                      </Tooltip>
                      : null}
                    <h3 >
                      {/* {this.state.Mision.text} */}
                      Texto Aqui
                    </h3>
                  </Col>
                </Row>
                <Row>
                  <Col className="ml-auto mr-auto text-center" md="8">
                    <br></br>
                    <h2 className="title">Nuestra Visión</h2>
                    {this.props.admin ?
                      <Tooltip title="Editar" aria-label="add">
                        <Fab variant="extended" onClick={event => this.handleClickOpen(event, this.state.Vision)} >
                          <EditIcon />
                        </Fab>
                      </Tooltip>
                      : null}
                    <h3 >
                      {/* {this.state.Vision.text} */}
                      Texto Aqui
                    </h3>
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            minWidth="5000"
            maxWidth="10000"            >
            <DialogTitle id="alert-dialog-title"><h6 style={{ color: '#676768' }}>Editar</h6></DialogTitle>
            <DialogContent>
              <FormControl fullWidth style={{ margin: 8 }} variant="outlined">
                <TextField
                  id="outlined-multiline-static"
                  fullWidth
                  value={this.state.msgdiag}
                  onChange={this.handleChangetype('msgdiag')}
                  multiline
                  variant="outlined"
                  rows="4"
                  InputProps={{
                    readOnly: this.state.showques ? true : false,
                  }}
                />
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClick} color="primary" autoFocus>
                Guardar
              </Button>
              <Button onClick={this.handleClose} color="primary" autoFocus>
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>
          <DarkFooter />
        </div>
      </>
    );
  }
}
export default InfoPage;